import { render, staticRenderFns } from "./StaffListPage.vue?vue&type=template&id=507263a1&scoped=true"
import script from "./StaffListPage.vue?vue&type=script&lang=js"
export * from "./StaffListPage.vue?vue&type=script&lang=js"
import style0 from "./StaffListPage.vue?vue&type=style&index=0&id=507263a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507263a1",
  null
  
)

export default component.exports